// JS mirror of tokens.css, for places that need values in TS (charts, canvas, inline logic).
export const colors = {
  accent: "#DC2D49",
  navy: "#20242E",
  navySoft: "#2A2D3A",
  success: "#1E8E55",
  bg: "#F0EEE8",
  surface: "#F8F8FA",
  surfaceAlt: "#EEEFF2",
  border: "#E9EAEE",
  text: "#20242E",
  textSecondary: "#5F6470",
  textMuted: "#8A8F9B",
  textFaint: "#B4B8C1",
} as const;

export const radius = {
  sm: 11,
  md: 14,
  lg: 22,
} as const;

// Shared default (5 of 6 apps) — Guest Portal overrides locally to SF Pro
// Display; see the note in tokens.css.
export const fontSans = '"Plus Jakarta Sans", system-ui, sans-serif';
